export default __webpack_public_path__ + "static/media/info.ae638cf1.svg";